/* SolutionsSwitcherComponent.js */

"use strict";
const _ = require('lodash');
const EventEmitter = require('events').EventEmitter;
const SteveRouter = require("@gluenetworks/steve_core_router");
const Renderer = require("./SolutionsSwitcherRenderer");
const CompactRenderer = require("./SolutionsSwitcherCompactRenderer");
const SOLUTION_USER_PERM_MAP = require("../SolutionPermsMap");

class SolutionsSwitcherComponent extends EventEmitter {
    constructor(config) {
        super();
        this._router = new SteveRouter(window, window.history);
        this._solutionManager = _.get(config, "solutionManager");
        this._di = _.get(this._solutionManager, "_di");
        this._compactView = _.get(config, "compactView", false);
        // TODO Make $teve.licenseRestriction accessible from ME
        // Temporary code to make ME work until properly fixed
        this._licenseRestriction = undefined;
        if (this._di.getRegistered('$teve.licenseRestriction')) {
            this._licenseRestriction = this._di.getRegistered('$teve.licenseRestriction').registeredObj;
        }
        this._userSession = undefined;
        if (this._di.getRegistered('$teve.userSession')) {
            this._userSession = this._di.getRegistered('$teve.userSession').registeredObj;
        }
        this._userAuthorisedActions = undefined;

        if (this._userSession) {
            this._userAuthorisedActions = _.get(this._userSession, 'user.authorizedActions', undefined);
        }
        if (this._compactView) {
            this._renderer = new CompactRenderer(this);
        } else {
            this._renderer = new Renderer(this);
        }

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    /** BEGIN - SolutionTypes ************************/

    get solutionTypes() {
        return this.getSolutionTypes();
    }

    get renderer() {
        return this.getRenderer();
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    _registerListeners() {
        this._solutionManager.on('activeSolutionChanged', this._activeSolutionChanged = this._activeSolutionChanged.bind(this));
        if (this._licenseRestriction) {
            this._licenseRestriction.on('Data', this._onLicensesUpdated = this._onLicensesUpdated.bind(this));
        }
    }

    _unregisterListeners() {
        this._solutionManager.removeListener('activeSolutionChanged', this._activeSolutionChanged);
        if (this._licenseRestriction) {
            this._licenseRestriction.removeListener('Data', this._onLicensesUpdated);
        }
    }

    getSolutionsForGroup(name) {
        return this._solutionManager.getSolutionsForGroup(name);
    }

    getSolutionTypes() {
        return this._solutionManager.getSolutionGroupNames();
    }

    getSolutionUrl(solutionName) {
        return this._solutionManager.getSolutionUrl(solutionName);
    }

    setUserData(user) {
        this._setUserAuthorisedActions(user.authorizedActions);
    }

    _setUserAuthorisedActions(authorizedActions) {
        this._userAuthorisedActions = authorizedActions;
        this.refresh();
    }

    checkIfRestricted(solution) {
        let isLicenseRestricted = true,
            isUserRestricted = true;

        if (this._userAuthorisedActions && this._licenseRestriction) {
            isLicenseRestricted = this._licenseRestriction.checkLicense(solution.license);
            if (solution.name === "system_settings" || solution.name === "rpa") {
                isUserRestricted = false;
            } else {
                const userPermIndex = this._userAuthorisedActions.indexOf(SOLUTION_USER_PERM_MAP[solution.name]);
                isUserRestricted =  (userPermIndex >= 0) ? false : true;
            }
            return !(isLicenseRestricted && !isUserRestricted);
        }
    }

    checkIfDashboardRestricted() {
        let isUserRestricted = true;

        if(this._userAuthorisedActions) {
            const userPermIndex = this._userAuthorisedActions.indexOf(SOLUTION_USER_PERM_MAP.dashboard);
            isUserRestricted =  (userPermIndex >= 0) ? false : true;
        }

        return isUserRestricted;
    }

    /** END - SolutionTypes ************************/

    refresh() {
        this.emit('Refresh');
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        return this._renderer.shutdown()
            .then(() => {
                this._renderer = undefined;
                this._userAuthorisedActions = undefined;
                this._userSession = undefined;
            }, (/*err*/) => {
                //TODO - Handle any errors in shutting down.
            });
    }

    _activeSolutionChanged(slnDef) {
        this.emit('activeSolutionChanged', slnDef);
    }

    _onLicensesUpdated() {
        this.refresh();
    }

    // toJSON(){
    //     let JSONObj = {};
    //     return JSONObj;
    // }
    // fromJSON(JSONObj){
    //
    // }
    // updateFromJSON(JSONObj){
    //
    // }
    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/
    _onHrefClicked(data) {
        this.emit('hrefClicked', data);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = SolutionsSwitcherComponent;
